import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function MembershipPageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}) {
  const navigate = useNavigate();

  return (
    <div className="mb-6 flex flex-col justify-between gap-4 xl:flex-row xl:items-center">
      <div>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-3 inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-600 hover:bg-slate-50"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>

        <h1 className="text-2xl font-black text-slate-900">{title}</h1>

        {description ? (
          <p className="mt-1 max-w-4xl text-sm leading-6 text-slate-500">
            {description}
          </p>
        ) : null}
      </div>

      {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
}